import { resolveId } from '@medplum/core'
import type { Reference, Task } from '@medplum/fhirtypes'
import { referenceDisplay } from '@seen/core/display'
import { Participant } from '@seen/core/models/patients/participant'
import { StandardTask } from '@seen/core/models/tasks/standard/standardTask'
import type { JSX } from 'react'
import { Link } from '#src/components/core/Link.tsx'
import { TaskMentionContent } from '#src/components/TaskMentionContent.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function TaskMention({
  task: taskReference,
}: {
  task: Reference<Task>
}): JSX.Element {
  const taskId = resolveId(taskReference)
  const { data: task } = useRead(StandardTask, taskReference)
  const { data: participant } = useRead(
    Participant,
    resolveId(task?.participant)
  )

  return (
    <Link
      to={
        participant
          ? `${participant.relativeUrl}/tasks/${taskId}`
          : `/tasks/${taskId}`
      }
      className="rounded-sm border-[0.5px] border-gray-450 bg-gray-470 box-decoration-clone px-1 py-px select-none group-[.ProseMirror-selectednode]:bg-[lch(53_52.26_286.91/0.4)] hover:bg-gray-460 [&&]:no-underline"
      tabIndex={-1}
    >
      <TaskMentionContent
        task={task}
        participant={participant}
        display={referenceDisplay(taskReference)}
      />
    </Link>
  )
}
